<template>
	<div class="job-search-input-wrapper mx-auto">
		<div
			class="job-search-input bg-white px-4 py-4 shadow border w-100" :class="{'abs-positioning': enableCustomPositioning }">
			<p class="d-sm-block mb-3 text-center display-4">{{ $t('search_your_dream_job') }}</p>
			<div class="form-group form-group-with-search d-flex align-items-center position-relative">
				
                
                 
                <select v-model="department" class="form-control" style="border-radius:5px !important">
                    <option value="">{{ $t('department') }}</option>
                    <option v-for="item in departmentList" :value="item.id">{{ item.name }}</option>
                </select>
                <select v-model="experience" class="form-control" style="border-radius:5px !important">
                    <option value=""> {{ $t('experience_level') }}</option>
                    <option v-for="item in experienceList" :value="item.id">{{ item.name }}</option>
                </select>
				<select v-model="location" class="form-control" style="border-radius:5px !important">
                    <option value=""> {{ $t('company_location') }}</option>
                    <option v-for="item in locations" :value="item.id">{{ item.address }}</option>
                </select>
                <button @click="handleSubmit" class="btn btn-info">{{ $t('search') }}</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NewSearch",
	props: {
		readonly: {
			type: Boolean,
			default: true
		},
		enableCustomPositioning: {
			type: Boolean,
			default: false
		},
        experienceList: {
            type: Array,
            required: true
        },
        departmentList: {
            type: Array,
            required: true
        },
        locations: {
            type: Array,
            required: true
        }
	},
	data() {
        return {
            searchTerm: '',
            experience: '',
            department: '',
            location: '',
            showClearBtn: false
        }
	},
	methods: {
		handleChange(e) {
			this.$emit('input', e.target.value);
		},
        handleEnterPress(e) {
            this.showClearBtn = true;
            this.$emit('enterpress', e.target.value)
        },
        handleSubmit() {
            console.log("updated list 3")
            this.$emit('submit', {
                department: this.department,
                experience: this.experience,
                location: this.location
            })
        },
        handleClearSearchTermClick() {
            this.searchTerm = '';
            this.showClearBtn = false
            this.$emit('search-term-clear')
        }
	},
}
</script>

<style lang="scss" scoped>
.job-search-input-wrapper {
	position: relative;
}



.job-search-input {
	margin: 0 auto;
	border-radius: 1.25rem;

	p {
		font-size: 16px;
	}

	input {
		padding: 0.5rem 1rem;
		border-radius: 2rem;
	}
}

.abs-positioning {
	z-index: 2;
	position: absolute;
	top: 0%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.to-right {
    display: block;
    position: absolute;
    right: 0.75rem;
}
</style>
